// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compass[data-v-519876a8]{width:40px;height:40px}.round-bg[data-v-519876a8]{width:40px;height:40px;border-radius:20px;border:1px solid #9a7c5d}.triangle[data-v-519876a8]{position:absolute;-webkit-transform-origin:top center;transform-origin:top center;top:35px;left:28px;width:15px;height:15px;fill:#9a7c5d}", ""]);
// Exports
module.exports = exports;
